/* Outback Ironbark — theme JS (deferred) */
(function () {
  'use strict';

  /* ---------- product quantity to enquiry (no cart mutation) ---------- */
  function syncProductQuoteQuantity(root) {
    if (!root) return;
    var input = root.querySelector('#p-qty');
    var enquiryInput = input ? null : root.querySelector('[data-enquiry-quantity]');
    input = input || enquiryInput;
    var quantity = input ? String(input.value).trim() : '';
    var valid = /^[1-9][0-9]{0,6}$/.test(quantity) && Number(quantity) <= 1000000;
    if (enquiryInput) enquiryInput.setCustomValidity(quantity && !valid ? enquiryInput.dataset.invalidMessage : '');
    root.querySelectorAll('a[data-product-quote]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.searchParams.get('product') !== link.dataset.productQuote) return;
        url.searchParams.delete('requested_quantity');
        if (valid) url.searchParams.set('requested_quantity', quantity);
        link.href = url.toString();
      } catch (_) { /* Keep the original working link. */ }
    });
    return enquiryInput;
  }
  document.querySelectorAll('a[data-product-quote]').forEach(function (link) {
    syncProductQuoteQuantity(link.closest('.shopify-section'));
  });
  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (event.target.id === 'p-qty' || event.target.id === 'availability-quantity') syncProductQuoteQuantity(event.target.closest('.shopify-section'));
    });
  });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-product-quote]');
    if (link) {
      var enquiryInput = syncProductQuoteQuantity(link.closest('.shopify-section'));
      try {
        var url = new URL(link.href, window.location.href);
        if (enquiryInput && url.origin === window.location.origin && url.searchParams.get('product') === link.dataset.productQuote && !enquiryInput.checkValidity()) {
          event.preventDefault();
          enquiryInput.reportValidity();
        }
      } catch (_) { /* Preserve the original destination when it cannot be parsed. */ }
    }
  }, true);

  /* ---------- a11y announcer ---------- */
  function announce(msg) {
    var el = document.getElementById('a11y-status');
    if (el) { el.textContent = ''; el.textContent = msg; }
  }

  /* ---------- focus trap helper ---------- */
  function focusables(root) {
    var sel = 'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(root.querySelectorAll(sel), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }
  function trapTab(container, e) {
    if (e.key !== 'Tab') return;
    var els = focusables(container);
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  /* ---------- generic drawer ---------- */
  var activeDrawer = null;
  function drawerIsOpen() {
    return document.documentElement.classList.contains('no-scroll') ||
      Boolean(document.querySelector('#cart-drawer.is-open, #nav-drawer.is-open'));
  }
  function makeDrawer(el, opts) {
    var lastFocus = null;
    var opened = false;
    var api = { open: open, close: close, el: el, returnFocus: function () { return lastFocus; } };
    function visibleFocusTarget(target) {
      return target && document.contains(target) && !target.closest('.drawer') && !target.disabled &&
        target.matches('a[href], button, input, select, textarea, summary, [tabindex]') &&
        target.getClientRects().length > 0 && window.getComputedStyle(target).visibility !== 'hidden';
    }
    function restoreFocus() {
      var target = lastFocus;
      if (!visibleFocusTarget(target)) {
        var ownTrigger = el.id === 'cart-drawer' ? '[data-cart-open]' : '[data-drawer-toggle]';
        var candidates = Array.from(document.querySelectorAll(ownTrigger)).concat(Array.from(document.querySelectorAll('[data-cart-open], [data-drawer-toggle]')));
        target = candidates.find(visibleFocusTarget);
      }
      if (target) target.focus();
    }
    function open() {
      if (opened && activeDrawer === api) return;
      lastFocus = document.activeElement;
      if (activeDrawer && activeDrawer !== api) {
        if (activeDrawer.el.contains(lastFocus)) lastFocus = activeDrawer.returnFocus();
        activeDrawer.close(false);
      }
      var openPopup = document.getElementById('ob-popup');
      if (openPopup && !openPopup.hidden) {
        if (openPopup.contains(lastFocus)) lastFocus = document.querySelector(el.id === 'cart-drawer' ? '[data-cart-open]' : '[data-drawer-toggle]');
        openPopup.hidden = true;
        openPopup.setAttribute('aria-hidden', 'true');
      }
      el.classList.add('is-open');
      opened = true;
      activeDrawer = api;
      el.removeAttribute('aria-hidden');
      document.documentElement.classList.add('no-scroll');
      if (opts.onToggle) opts.onToggle(true);
      var els = focusables(el.querySelector('.drawer__panel'));
      if (els.length) els[0].focus();
    }
    function close(returnFocus) {
      if (!opened) return;
      opened = false;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (activeDrawer === api) activeDrawer = null;
      if (!activeDrawer) document.documentElement.classList.remove('no-scroll');
      if (opts.onToggle) opts.onToggle(false);
      if (returnFocus !== false && !activeDrawer) restoreFocus();
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest(opts.closeSelector)) close();
    });
    el.addEventListener('keydown', function (e) {
      if (!opened) return;
      if (e.key === 'Escape') { if (!e.defaultPrevented) close(); return; }
      trapTab(el.querySelector('.drawer__panel'), e);
    });
    return api;
  }

  /* ---------- nav drawer ---------- */
  var navEl = document.getElementById('nav-drawer');
  var navToggle = document.querySelector('[data-drawer-toggle]');
  if (navEl && navToggle) {
    var navDrawer = makeDrawer(navEl, {
      closeSelector: '[data-drawer-close]',
      onToggle: function (open) { navToggle.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    });
    navToggle.addEventListener('click', function () {
      navEl.classList.contains('is-open') ? navDrawer.close() : navDrawer.open();
    });
  }

  /* ---------- desktop navigation disclosures ---------- */
  var navItems = Array.prototype.slice.call(document.querySelectorAll('.hdr__item--has'));
  function navTrigger(item) { return item.querySelector('[data-nav-trigger]'); }
  function closeNavItem(item, returnFocus) {
    var trigger = navTrigger(item);
    item.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (returnFocus && trigger) trigger.focus();
  }
  function closeNavItems(except) {
    navItems.forEach(function (item) { if (item !== except) closeNavItem(item, false); });
  }
  function openNavItem(item) {
    var trigger = navTrigger(item);
    closeNavItems(item);
    item.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }
  navItems.forEach(function (item) {
    var trigger = navTrigger(item);
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (trigger.hasAttribute('data-nav-disclosure')) item.classList.contains('is-open') ? closeNavItem(item, false) : openNavItem(item);
      else if (window.matchMedia('(hover: hover)').matches) openNavItem(item);
      else item.classList.contains('is-open') ? closeNavItem(item, false) : openNavItem(item);
    });
    item.addEventListener('mouseenter', function () {
      if (!trigger.hasAttribute('data-nav-disclosure') && window.matchMedia('(hover: hover)').matches) openNavItem(item);
    });
    item.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover: hover)').matches && !item.contains(document.activeElement)) closeNavItem(item, false);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hdr__item--has')) closeNavItems();
  });
  document.addEventListener('focusin', function (e) {
    if (!e.target.closest('.hdr__item--has')) closeNavItems();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openItem = document.querySelector('.hdr__item--has.is-open');
    if (openItem) { e.preventDefault(); closeNavItem(openItem, true); }
  });

  /* ---------- cart drawer + AJAX cart ---------- */
  var cartEl = document.getElementById('cart-drawer');
  var cartDrawer = cartEl ? makeDrawer(cartEl, { closeSelector: '[data-cart-close]' }) : null;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && cartDrawer) { e.preventDefault(); cartDrawer.open(); }
  });

  function refreshCartDrawer() {
    var editRevision = typeof cartEditRevision === 'number' ? cartEditRevision : 0;
    var refreshError = window.OB_CART_REFRESH_ERROR || 'We could not refresh your cart.';
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { if (!r.ok) throw new Error(refreshError); return r.json(); })
      .then(function (sections) {
        if (!sections || typeof sections['cart-drawer'] !== 'string' || !sections['cart-drawer'].trim()) throw new Error(refreshError);
        var tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];
        var fresh = tmp.querySelector('#cart-drawer');
        var cur = document.getElementById('cart-drawer');
        if (!fresh || !cur) throw new Error(refreshError);
        if (typeof cartEditRevision === 'number' && editRevision !== cartEditRevision) return;
        var focusedKey = typeof cartDraftFocus === 'function' ? cartDraftFocus(cur) : null;
        cur.innerHTML = fresh.innerHTML;
        if (typeof restoreCartDrafts === 'function') restoreCartDrafts(cur, focusedKey);
        var count = cur.querySelector('[data-cart-count]');
        if (count) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = count.textContent;
          });
        }
        applyXsellDismissals();
      });
  }

  function refreshAfterCartAdd() {
    var revision = cartEditRevision;
    var jobs = [refreshCartDrawer()];
    if (document.querySelector('[data-cart-page]')) jobs.push(refreshCartPage());
    return Promise.all(jobs).then(function () {
      if (revision !== cartEditRevision) return refreshAfterCartAdd();
    });
  }
  function addCartItems(options, fallbackError) {
    if (cartEditsInFlight || Object.keys(qtyTimers).length || Object.keys(cartReadyEdits).length || Object.keys(cartDrafts).length) {
      var refusal = new Error(window.OB_CART_ADD_BLOCKED);
      refusal.cartAddBlocked = true;
      return Promise.reject(refusal);
    }
    cartAddsPending++;
    showCartEditStatus();
    return fetch('/cart/add.js', options)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || fallbackError); });
        return r.json();
      })
      .then(function () { cartEditRevision++; return refreshAfterCartAdd(); })
      .then(function () {
        cartAddsPending--;
        showCartEditStatus();
        if (cartAddNeedsReview) throw new Error(window.OB_CART_REFRESH_ERROR);
        if (!cartAddsPending) runCartEdit();
      }, function (error) {
        cartAddsPending--;
        cartAddNeedsReview = true;
        cartEditRevision++;
        showCartEditStatus();
        // Re-sync with the server's cart; once the drawer shows the true cart, adds and edits work again.
        refreshAfterCartAdd().then(function () {
          cartAddNeedsReview = false;
          showCartEditStatus();
          if (!cartAddsPending) runCartEdit();
        }, function () { /* keep the review state; the status line links to /cart */ });
        throw error;
      });
  }

  // AJAX add-to-cart: any product form
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    if (form.hasAttribute('data-add-pending')) return;
    form.setAttribute('data-add-pending', '');
    form.setAttribute('aria-busy', 'true');
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var old = form.querySelector('.form-err');
    if (old) old.remove();
    var finishAdd = function () {
      form.removeAttribute('data-add-pending'); form.removeAttribute('aria-busy');
      if (btn) { btn.disabled = false; btn.textContent = orig; }
    };
    var showAddError = function (err) {
      var p = document.createElement('p');
      p.className = 'form-err'; p.setAttribute('role', 'alert');
      p.textContent = err.message + ' ';
      if (!err.cartAddBlocked && window.OB_CART_URL && window.OB_CART_CHECK_LABEL) {
        var link = document.createElement('a');
        link.href = window.OB_CART_URL; link.textContent = window.OB_CART_CHECK_LABEL;
        p.appendChild(link);
      }
      form.appendChild(p);
      announce(err.message);
      var errBox = p.getBoundingClientRect();
      if (errBox.top < 0 || errBox.bottom > window.innerHeight) p.scrollIntoView({ block: 'center' });
    };

    // complete-the-system: checked add-ons ride along in one multi-item add
    var addonChecks = form.querySelectorAll('[data-addon-check]:checked');
    if (addonChecks.length) {
      var fd = new FormData(form);
      var items = [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }];
      var mainQty = parseInt(fd.get('quantity') || '1', 10);
      addonChecks.forEach(function (c) {
        items.push({
          id: parseInt(c.getAttribute('data-variant'), 10),
          quantity: c.hasAttribute('data-match-main-qty') ? mainQty : 1
        });
      });
      document.dispatchEvent(new CustomEvent('ob:addItems', { detail: { items: items, onError: showAddError, onComplete: finishAdd } }));
      return;
    }

    addCartItems({ method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) }, 'Could not add to cart')
      .then(function () { announce('Added to cart'); cartDrawer.open(); })
      .catch(showAddError)
      .then(finishAdd);
  });
  window.OB_NATIVE_CART_READY = Boolean(cartDrawer);

  /* Quantity +/−, typed input, and remove (drawer and cart page share these
     attributes). Rewritten 27 Jul: the old qtyBusy guard DROPPED every click that
     arrived while a request was in flight, so rapid +/+/+ registered a fraction of
     the presses, and there was no way to type a quantity at all (a bulk buyer
     couldn't enter 160). Now the input is the source of truth: +/− update it
     instantly on screen, typing edits it directly, and each line's changes
     coalesce into ONE debounced /cart/change.js call — nothing is ever swallowed.
     Remove skips the debounce; edit-and-refresh cycles run one at a time. */
  var qtyTimers = {};
  var cartAddsPending = 0;
  var cartAddNeedsReview = false;
  var cartEditsInFlight = 0;
  var cartEditRevision = 0;
  var cartReadyEdits = {};
  var cartDrafts = {};
  var cartActiveEdit = null;
  var cartEditsFailed = false;
  var cartEditNotice = '';
  function cartEditPending() {
    return cartAddsPending > 0 || cartEditsInFlight > 0 || Object.keys(qtyTimers).length > 0 || Object.keys(cartReadyEdits).length > 0;
  }
  function showCartEditStatus() {
    document.querySelectorAll('[data-cart-edit-status]').forEach(function (status) {
      status.hidden = !cartEditPending() && !cartAddNeedsReview;
      if (cartAddNeedsReview) {
        status.textContent = window.OB_CART_REFRESH_ERROR + ' ';
        var link = document.createElement('a');
        link.href = window.OB_CART_URL || '/cart';
        link.textContent = window.OB_CART_CHECK_LABEL;
        status.appendChild(link);
      }
    });
  }
  function cartQuantity(input) {
    var value = String(input.value).trim();
    var quantity = Number(value);
    var valid = /^[0-9]+$/.test(value) && Number.isSafeInteger(quantity);
    input.setCustomValidity(valid ? '' : input.getAttribute('data-quantity-invalid'));
    return valid ? quantity : null;
  }
  function cancelQtySync(input) {
    var key = input.getAttribute('data-line-key');
    clearTimeout(qtyTimers[key]);
    delete qtyTimers[key];
    delete cartReadyEdits[key];
    showCartEditStatus();
  }
  function cartDraftFocus(root) {
    var active = document.activeElement;
    return active && root.contains(active) && active.hasAttribute('data-qty-input') ? active.getAttribute('data-line-key') : null;
  }
  function restoreCartDrafts(root, focusedKey) {
    root.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var draft = cartDrafts[input.getAttribute('data-line-key')];
      if (draft) {
        if (input.value !== draft.value) input.value = draft.value;
        cartQuantity(input);
      }
      if (focusedKey === input.getAttribute('data-line-key')) input.focus({ preventScroll: true });
    });
  }
  function rememberCartDraft(input) {
    var key = input.getAttribute('data-line-key');
    if (!key) return;
    cartDrafts[key] = { value: String(input.value), revision: ++cartEditRevision };
    restoreCartDrafts(document);
  }
  function cartInputsValid(root) {
    if (cartAddNeedsReview) {
      showCartEditStatus();
      var recovery = root.querySelector('[data-cart-edit-status]');
      if (recovery) recovery.focus();
      return false;
    }
    var inputs = root.querySelectorAll('[data-qty-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (cartQuantity(inputs[i]) === null) {
        cancelQtySync(inputs[i]); inputs[i].reportValidity(); return false;
      }
    }
    if (cartEditPending()) {
      showCartEditStatus();
      var status = root.querySelector('[data-cart-edit-status]');
      if (status) status.focus();
      return false;
    }
    return true;
  }
  function queueQtySync(key, qty) {
    if (!key) return;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      cartReadyEdits[key] = { key: key, quantity: qty, revision: cartDrafts[key].revision };
      runCartEdit();
    }, 450);
    showCartEditStatus();
  }
  function runCartEdit() {
    if (cartEditsInFlight || cartAddsPending || cartEditsFailed || cartAddNeedsReview) return;
    var key = Object.keys(cartReadyEdits)[0];
    if (!key) { showCartEditStatus(); return; }
    var edit = cartReadyEdits[key];
    delete cartReadyEdits[key];
    cartActiveEdit = edit;
    cartEditsInFlight = 1;
    showCartEditStatus();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: edit.quantity })
    })
      .then(function (r) {
        if (r.status === 422) return r.json().then(function (j) { cartEditNotice = (j && (j.description || j.message)) || ''; }, function () { cartEditNotice = ''; });
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function () {
        cartEditRevision++;
        if (cartDrafts[key] && cartDrafts[key].revision === edit.revision) delete cartDrafts[key];
        var jobs = [refreshCartDrawer()];
        if (document.querySelector('[data-cart-page]')) jobs.push(refreshCartPage());
        return Promise.all(jobs);
      })
      .then(function () {
        cartEditsInFlight = 0;
        cartActiveEdit = null;
        showCartEditStatus();
        if (cartEditNotice) {
          var notice = cartEditNotice;
          cartEditNotice = '';
          document.querySelectorAll('[data-cart-edit-status]').forEach(function (status) { status.hidden = false; status.textContent = notice; });
          announce(notice);
        } else if (!cartEditPending() && !cartAddNeedsReview) announce(edit.quantity === 0 ? 'Item removed' : 'Cart updated');
        runCartEdit();
      })
      .catch(function () {
        cartEditsFailed = true;
        window.location.href = window.OB_CART_URL || '/cart';
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    var input = b.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    cancelQtySync(input);
    rememberCartDraft(input);
    var quantity = cartQuantity(input);
    if (quantity === null) { input.reportValidity(); return; }
    var next = Math.max(0, quantity + Number(b.getAttribute('data-qty-change')));
    if (!Number.isSafeInteger(next)) { queueQtySync(b.getAttribute('data-line-key'), quantity); return; }
    input.value = next;
    rememberCartDraft(input);
    queueQtySync(b.getAttribute('data-line-key'), next);
  });
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-qty-input]');
    if (!input) return;
    cancelQtySync(input);
    rememberCartDraft(input);
    var qty = cartQuantity(input);
    if (qty === null) return;
    queueQtySync(input.getAttribute('data-line-key'), qty);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-qty-input]');
    if (!input) return;
    cancelQtySync(input);
    rememberCartDraft(input);
    var qty = cartQuantity(input);
    if (qty === null) { input.reportValidity(); return; }
    input.value = qty;
    queueQtySync(input.getAttribute('data-line-key'), qty);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-remove]');
    if (!b) return;
    var key = b.getAttribute('data-line-key');
    if (!key) return;
    if (cartActiveEdit && cartActiveEdit.key === key && cartActiveEdit.quantity === 0) return;
    clearTimeout(qtyTimers[key]);
    delete qtyTimers[key];
    cartDrafts[key] = { value: '0', revision: ++cartEditRevision };
    cartReadyEdits[key] = { key: key, quantity: 0, revision: cartEditRevision };
    restoreCartDrafts(document);
    runCartEdit();
    showCartEditStatus();
  });

  document.addEventListener('click', function (e) {
    var control = e.target.closest('a[href], button[name="checkout"]');
    if (!control) return;
    var root = control.closest('#cart-drawer, [data-cart-page]');
    if (!root) return;
    if (control.tagName === 'A') {
      var destination = new URL(control.href, window.location.href);
      if (destination.origin !== window.location.origin || !/\/checkout\/?$/.test(destination.pathname)) return;
    }
    if (!cartInputsValid(root)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var root = e.target.closest('#cart-drawer, [data-cart-page]');
    if (root && !cartInputsValid(root)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function refreshCartPage() {
    var editRevision = cartEditRevision;
    var el = document.querySelector('[data-cart-page]');
    var section = el && el.getAttribute('data-section-id');
    if (!section) return Promise.resolve();
    var refreshError = window.OB_CART_REFRESH_ERROR || 'We could not refresh your cart.';
    return fetch(window.location.pathname + '?sections=' + section)
      .then(function (r) { if (!r.ok) throw new Error(refreshError); return r.json(); })
      .then(function (sections) {
        if (!sections || typeof sections[section] !== 'string' || !sections[section].trim()) throw new Error(refreshError);
        var tmp = document.createElement('div');
        tmp.innerHTML = sections[section];
        var fresh = tmp.querySelector('[data-cart-page]');
        if (!fresh) throw new Error(refreshError);
        if (editRevision !== cartEditRevision) return;
        var focusedKey = cartDraftFocus(el);
        el.innerHTML = fresh.innerHTML;
        restoreCartDrafts(el, focusedKey);
      });
  }

  /* ---------- picket batch: bar dismiss, day countdown, notify capture ---------- */
  var abar = document.getElementById('abar');
  if (abar) {
    var abarDismissed = false;
    try {
      abarDismissed = window.sessionStorage && window.sessionStorage.getItem('pb_bar_hide');
    } catch (err) {
      /* Storage can be unavailable in privacy-restricted and embedded previews.
         The close button must still work for the current page. */
    }
    if (!abarDismissed) abar.hidden = false;
    abar.addEventListener('click', function (e) {
      if (e.target.closest('[data-abar-close]')) {
        e.preventDefault();
        abar.hidden = true;
        try {
          if (window.sessionStorage) window.sessionStorage.setItem('pb_bar_hide', '1');
        } catch (err) {
          /* Immediate dismissal still works when session persistence is blocked. */
        }
      }
    });
  }
  document.querySelectorAll('[data-batch-header]').forEach(function (h) {
    var d = h.getAttribute('data-batch-date');
    if (!d) return;
    var p = d.split('-');
    var target = new Date(+p[0], +p[1] - 1, +p[2]);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var days = Math.round((target - today) / 86400000);
    if (days <= 0) {
      h.textContent = 'NEXT BATCH LANDS TODAY';
    } else {
      var span = h.querySelector('[data-batch-days]');
      if (span) span.textContent = days;
    }
  });
  document.querySelectorAll('[data-batch-notify]').forEach(function (box) {
    var form = box.querySelector('[data-batch-notify-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      var btn = form.querySelector('button');
      btn.disabled = true;
      /* kmail-lists AJAX endpoint — the only Klaviyo subscribe path that serves CORS
         to this storefront origin (client/subscriptions blocks it; verified 19 Jul). */
      var kbody = new URLSearchParams();
      kbody.append('g', box.getAttribute('data-list'));
      kbody.append('email', email);
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', { method: 'POST', body: kbody })
        .then(function (r) {
          if (!r.ok) throw new Error('subscribe failed ' + r.status);
          return r.json();
        })
        .then(function (j) {
          if (j && j.success === false) throw new Error('subscribe rejected');
          form.hidden = true;
          box.querySelector('.bnotify__lede').hidden = true;
          box.querySelector('.bnotify__ok').hidden = false;
        })
        .catch(function () {
          btn.disabled = false;
          box.querySelector('.bnotify__err').hidden = false;
        });
    });
  });

  /* ---------- product page ---------- */
  /* tap-to-zoom on the main gallery image (dead-click fix, 18 Jul): a tap on the
     image zooms at the tap point; second tap resets. No dead taps on the hero shot. */
  var gmainWrap = document.querySelector('.gallery__main');
  var galleryZoomButton = document.querySelector('[data-gallery-zoom]');
  function setGalleryZoom(img, zoomed, origin) {
    if (!gmainWrap) return;
    gmainWrap.classList.toggle('is-zoomed', zoomed);
    gmainWrap.querySelectorAll('img').forEach(function (image) { image.style.transformOrigin = ''; });
    if (img && zoomed) img.style.transformOrigin = origin || '50% 50%';
    if (galleryZoomButton) {
      galleryZoomButton.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      galleryZoomButton.textContent = zoomed ? galleryZoomButton.dataset.resetLabel : galleryZoomButton.dataset.zoomLabel;
    }
  }
  function resetGalleryZoom() { setGalleryZoom(null, false); }
  if (galleryZoomButton && document.getElementById('g-main')) {
    galleryZoomButton.hidden = false;
    galleryZoomButton.addEventListener('click', function () {
      setGalleryZoom(document.getElementById('g-main'), !gmainWrap.classList.contains('is-zoomed'), '50% 50%');
    });
  }
  if (gmainWrap) {
    gmainWrap.addEventListener('click', function (e) {
      /* video support (22 Jul): never hijack clicks on a video/iframe (controls),
         and zoom the currently VISIBLE image in the media gallery. Image-only
         products fall through to #g-main exactly as before. */
      if (e.target.closest('video, .gmedia--video')) return;
      var img = gmainWrap.querySelector('img.gmedia:not(.gmedia--off)') || document.getElementById('g-main');
      if (!img) return;
      if (gmainWrap.classList.contains('is-zoomed')) {
        resetGalleryZoom();
      } else {
        var r = gmainWrap.getBoundingClientRect();
        var ox = ((e.clientX - r.left) / r.width) * 100;
        var oy = ((e.clientY - r.top) / r.height) * 100;
        setGalleryZoom(img, true, ox + '% ' + oy + '%');
      }
    });
  }

  var variantSel = document.getElementById('p-variant');
  if (variantSel) {
    variantSel.addEventListener('change', function () {
      var opt = variantSel.options[variantSel.selectedIndex];
      var price = opt.getAttribute('data-price');
      var img = opt.getAttribute('data-img');
      var priceEl = document.getElementById('p-price');
      if (priceEl && price) priceEl.innerHTML = price + ' <small>inc GST</small>';
      var sticky = document.getElementById('s-price');
      if (sticky && price) sticky.textContent = price;
      var main = document.getElementById('g-main');
      if (main && img) { resetGalleryZoom(); main.src = img; }
      var sku = opt.getAttribute('data-sku');
      var skuEl = document.getElementById('p-sku');
      if (skuEl) skuEl.textContent = sku ? '· SKU ' + sku : '';
    });
  }
  /* image-only gallery thumbs (original path — [data-full] scoping keeps this off
     the media-gallery buttons, which handle themselves below) */
  document.querySelectorAll('.gallery__thumbs img[data-full]').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.gallery__thumbs img[data-full]').forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
      var main = document.getElementById('g-main');
      if (main) { resetGalleryZoom(); main.src = t.getAttribute('data-full'); main.alt = t.alt; }
    });
    t.setAttribute('tabindex', '0');
    t.setAttribute('role', 'button');
    t.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
    });
  });

  /* media-gallery thumbs (video support, 22 Jul): native buttons switch the
     .gmedia items; a video pauses when switched away; nothing ever autoplays. */
  document.addEventListener('click', function (e) {
    var mt = e.target.closest('[data-media-thumb]');
    if (!mt) return;
    var gal = mt.closest('.gallery');
    if (!gal) return;
    resetGalleryZoom();
    var idx = mt.getAttribute('data-media-thumb');
    gal.querySelectorAll('[data-media-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === mt); });
    gal.querySelectorAll('.gallery__main .gmedia').forEach(function (m) {
      var on = m.getAttribute('data-media') === idx;
      m.classList.toggle('gmedia--off', !on);
      if (!on && m.tagName === 'VIDEO') m.pause();
    });
  });
  var bar = document.getElementById('stickybar');
  var buy = document.querySelector('.buy');
  if (bar && buy && 'IntersectionObserver' in window) {
    // Show the sticky bar whenever the real Add button AND the price are both off screen (watching the
    // whole .buy box hid the bar while shoppers scrolled through the setup chooser and extras).
    var stickyWatched = [buy.querySelector('[type="submit"]') || buy];
    var stickyPrice = document.getElementById('p-price');
    if (stickyPrice) stickyWatched.push(stickyPrice);
    var stickySeen = [];
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { stickySeen[stickyWatched.indexOf(entry.target)] = entry.isIntersecting; });
      bar.classList.toggle('is-on', !stickySeen.some(Boolean));
    }, { threshold: 0 });
    stickyWatched.forEach(function (el) { stickyObserver.observe(el); });
  }

  /* ---------- review-badge fail-safe (hotfix 22 Jul; Option C retarget 26 Jul) ----------
     The stars badge links to the review section its OWN href names (now the
     native #native-product-reviews by default). Presence of that target is the
     liveness test — a timed content check would wrongly demote a working link.
     No target = demote to plain text so the badge is never a dead anchor. On
     click, move focus to the section once the jump lands (sticky-header offset
     via scroll-margin). */
  var revLink = document.querySelector('a.stars[data-review-link]');
  if (revLink) {
    var revWrap = document.querySelector(revLink.getAttribute('href'));
    if (!revWrap) {
      var revSpan = document.createElement('span');
      revSpan.className = revLink.className;
      revSpan.setAttribute('role', 'img');
      var revLabel = revLink.getAttribute('aria-label') || '';
      revSpan.setAttribute('aria-label', revLabel.replace(/^Read /, 'Rated: ') || 'Customer rating');
      while (revLink.firstChild) revSpan.appendChild(revLink.firstChild);
      revLink.parentNode.replaceChild(revSpan, revLink);
    } else {
      revWrap.setAttribute('tabindex', '-1');
      revLink.addEventListener('click', function () {
        setTimeout(function () { revWrap.focus({ preventScroll: true }); }, 60);
      });
    }
  }

  /* ---------- native reviews expand/collapse (REG-P15-1 Option C, 26 Jul) ----------
     Liquid renders EVERY available review plus a hidden toggle; this collapses the
     [data-nrev-extra] cards and reveals the button. JS off = all reviews visible and
     no control at all — never a dead or non-functional element. Labels come from the
     button's data attrs, which Liquid derives from the available set only. */
  document.querySelectorAll('[data-nrev-toggle]').forEach(function (btn) {
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    var extras = list ? list.querySelectorAll('[data-nrev-extra]') : [];
    if (!extras.length) return;
    var setState = function (collapsed) {
      extras.forEach(function (c) { c.hidden = collapsed; });
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      btn.textContent = collapsed ? btn.getAttribute('data-label-more') : btn.getAttribute('data-label-less');
    };
    btn.addEventListener('click', function () {
      var wasExpanded = btn.getAttribute('aria-expanded') === 'true';
      setState(wasExpanded);
      if (!wasExpanded) {
        extras[0].setAttribute('tabindex', '-1');
        extras[0].focus();
      }
    });
    setState(true);
    btn.hidden = false;
  });

  /* ---------- birthday promo: countdown + hard auto-expiry (27 Jul) ----------
     [data-bday-promo data-bday-end="ISO with +10:00 offset"] elements hide the
     moment the deadline passes — covers CDN-cached HTML, never shows an expired
     offer or a negative countdown. The end is an absolute instant (AEST offset in
     the ISO string), so every visitor's clock resolves the same moment.
     [data-bday-countdown] children get a calm d/h/m readout: 30-second tick, no
     seconds — nothing flashes. Countdown is aria-hidden; the deadline is stated in
     the visible copy for screen readers. */
  var bdayEls = document.querySelectorAll('[data-bday-promo]');
  if (bdayEls.length) {
    var bdayTick = function () {
      var now = Date.now();
      bdayEls.forEach(function (el) {
        var end = Date.parse(el.getAttribute('data-bday-end') || '');
        if (!end || now >= end) { el.hidden = true; return; }
        var c = el.querySelector('[data-bday-countdown]');
        if (!c) return;
        var left = end - now;
        var d = Math.floor(left / 86400000);
        var h = Math.floor(left % 86400000 / 3600000);
        var m = Math.floor(left % 3600000 / 60000);
        var sd = c.querySelector('[data-bd-d]'), sh = c.querySelector('[data-bd-h]'), sm = c.querySelector('[data-bd-m]');
        if (sd) sd.textContent = d;
        if (sh) sh.textContent = h;
        if (sm) sm.textContent = m;
        c.hidden = false;
      });
    };
    bdayTick();
    setInterval(bdayTick, 30000);
  }

  /* ---------- collection toolbar (sort + filters) ---------- */
  var sortSel = document.querySelector('[data-sort-by]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.href;
    });
  }
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', function () {
      var url = new URL(window.location.href);
      var sb = url.searchParams.get('sort_by');
      if (sb && !filterForm.querySelector('input[name="sort_by"]')) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'sort_by'; h.value = sb;
        filterForm.appendChild(h);
      }
    });
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) {
        if (typeof filterForm.requestSubmit === 'function') filterForm.requestSubmit();
        else filterForm.submit();
      }
    });
  }

  /* ---------- predictive search (any [data-search-wrap]: header bar + drawer) ---------- */
  document.querySelectorAll('[data-search-wrap]').forEach(function (wrap) {
    var sInput = wrap.querySelector('[data-search-input]');
    var sResults = wrap.querySelector('[data-search-results]');
    if (!sInput || !sResults) return;
    var sTimer = null;
    var searchRevision = 0;
    var searchPending = false;
    var escapeSearch = function (value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
    var closeSearch = function () { searchRevision += 1; clearTimeout(sTimer); searchPending = false; sResults.hidden = true; };
    var searchEscape = function (e) {
      if (e.key !== 'Escape' || (sResults.hidden && !searchPending)) return;
      e.preventDefault(); e.stopPropagation(); closeSearch(); sInput.focus();
    };
    var fullSearchLink = function (query) {
      var form = wrap.querySelector('form');
      var url = new URL(form.action, window.location.href);
      url.searchParams.set('type', 'product'); url.searchParams.set('q', query);
      return '<a class="searchpanel__hit searchpanel__all" href="' + escapeSearch(url.href) + '">' + escapeSearch(sResults.dataset.allResults) + '</a>';
    };
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var revision = ++searchRevision;
      var q = sInput.value.trim();
      searchPending = false;
      sResults.hidden = true; sResults.innerHTML = '';
      if (q.length < 2) return;
      searchPending = true;
      sTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { if (!r.ok) throw new Error('Search unavailable'); return r.json(); })
          .then(function (data) {
            if (revision !== searchRevision) return;
            searchPending = false;
            var prods = (((data.resources || {}).results || {}).products) || [];
            sResults.hidden = false;
            var qoHeld = (window.OB_QUOTE_ONLY || []).map(function (h) { return String(h).trim(); }).filter(Boolean);
            var postableHandles = (window.OB_POSTABLE_FREE || []).map(function (h) { return String(h).trim(); }).filter(Boolean);
            var hits = (Array.isArray(prods) ? prods : []).map(function (pr) {
              if (!pr || typeof pr.url !== 'string') return '';
              var url, match;
              try { url = new URL(pr.url, window.location.href); match = url.pathname.match(/\/products\/([^/]+)\/?$/); } catch (err) { return ''; }
              if (url.origin !== window.location.origin || !match) return '';
              var held = qoHeld.indexOf(match[1]) !== -1;
              var postable = postableHandles.indexOf(match[1]) !== -1;
              var picture = '<span class="searchpanel__noimg"></span>';
              if (typeof pr.image === 'string' && pr.image) {
                try { var img = new URL(pr.image, window.location.href); if (img.protocol === 'https:') { img.searchParams.set('width', '96'); picture = '<img src="' + escapeSearch(img.href) + '" width="48" height="48" alt="" loading="lazy">'; } } catch (err) { /* Text result remains usable without an image. */ }
              }
              var price = !held && /^\d+(\.\d{1,2})?$/.test(String(pr.price)) ? '<b>$' + escapeSearch(pr.price) + '</b>' : '';
              return '<a class="searchpanel__hit" href="' + escapeSearch(url.href) + '">' + picture
                + '<span class="searchpanel__copy"><span>' + escapeSearch(pr.title) + '</span>' + (postable ? '<small>' + escapeSearch(window.OB_FREE_DELIVERY_LABEL) + '</small>' : '') + '</span>' + price + '</a>';
            }).join('');
            sResults.innerHTML = (hits || '<p class="searchpanel__none">' + escapeSearch(sResults.dataset.noResults) + '</p>') + fullSearchLink(q);
          })
          .then(null, function () { if (revision !== searchRevision) return; searchPending = false; sResults.hidden = false; sResults.innerHTML = fullSearchLink(q); });
      }, 220);
    });
    sInput.addEventListener('keydown', function (e) {
      searchEscape(e);
      if (e.key === 'ArrowDown' && !sResults.hidden) { var first = sResults.querySelector('a'); if (first) { e.preventDefault(); first.focus(); } }
    });
    sResults.addEventListener('keydown', function (e) {
      searchEscape(e);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var links = Array.from(sResults.querySelectorAll('a'));
        var index = links.indexOf(document.activeElement);
        if (index < 0) return;
        e.preventDefault();
        var next = index + (e.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) sInput.focus(); else if (links[next]) links[next].focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeSearch();
    });
  });

  /* ---------- complete-the-system live combined total ---------- */
  var addonsBox = document.querySelector('[data-addons]');
  if (addonsBox) {
    var totalRow = addonsBox.querySelector('[data-addons-total]');
    var totalEl = addonsBox.querySelector('[data-combined-total]');
    var addonsForm = addonsBox.closest('form');
    var addonsQty = addonsForm && addonsForm.querySelector('[name="quantity"]');
    var recalc = function () {
      var mainQty = parseInt(addonsQty ? addonsQty.value : '1', 10) || 1;
      var cents = (parseInt(addonsBox.getAttribute('data-base'), 10) || 0) * mainQty;
      var any = false;
      addonsBox.querySelectorAll('[data-addon-check]:checked').forEach(function (c) {
        any = true;
        var addonQty = c.hasAttribute('data-match-main-qty') ? mainQty : 1;
        cents += (parseInt(c.getAttribute('data-price'), 10) || 0) * addonQty;
      });
      if (totalRow) totalRow.hidden = !any;
      if (totalEl) totalEl.textContent = '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    addonsBox.addEventListener('change', recalc);
    if (addonsQty) {
      addonsQty.addEventListener('input', recalc);
      addonsQty.addEventListener('change', recalc);
    }
    recalc();
  }

  /* ---------- cart cross-sell dismissal (one line, session-scoped) ---------- */
  function applyXsellDismissals() {
    document.querySelectorAll('[data-xsell]').forEach(function (x) {
      var dismissed = false;
      try { dismissed = sessionStorage.getItem('xsell-' + x.getAttribute('data-xsell')); } catch (err) { /* storage blocked: keep the cross-sell visible */ }
      if (dismissed) x.remove();
    });
  }
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-xsell-dismiss]');
    if (!d) return;
    var x = d.closest('[data-xsell]');
    if (x) { try { sessionStorage.setItem('xsell-' + x.getAttribute('data-xsell'), '1'); } catch (err) { /* storage blocked: dismiss for this page only */ } x.remove(); }
  });
  applyXsellDismissals();

  /* ---------- card quick add ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa || qa.disabled || !cartDrawer) return;
    e.preventDefault();
    e.stopPropagation();
    var orig = qa.textContent;
    var wasDisabled = qa.disabled;
    var errorHost = qa.closest('[data-xsell]') || qa.parentElement;
    if (qa.quickAddError) { qa.quickAddError.remove(); qa.quickAddError = null; }
    qa.disabled = true; qa.textContent = 'Adding…';
    qa.setAttribute('aria-busy', 'true');
    document.dispatchEvent(new CustomEvent('ob:addItems', { detail: {
      items: [{ id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 }],
      onError: function (error) {
        var message = document.createElement('p');
        message.className = 'form-err';
        message.setAttribute('data-quick-add-error', '');
        message.setAttribute('role', 'alert');
        message.textContent = (error.message || window.OB_CART_REFRESH_ERROR) + ' ';
        if (!error.cartAddBlocked) {
          var recovery = document.createElement('button');
          recovery.type = 'button'; recovery.className = 'btn btn--line';
          recovery.textContent = window.OB_CART_CHECK_LABEL;
          recovery.addEventListener('click', function (event) {
            event.preventDefault(); event.stopPropagation();
            window.location.href = window.OB_CART_URL || '/cart';
          });
          message.appendChild(recovery);
        }
        qa.quickAddError = message;
        errorHost.appendChild(message);
      },
      onComplete: function () { qa.disabled = wasDisabled; qa.textContent = orig; qa.removeAttribute('aria-busy'); }
    } }));
  });

  /* ---------- bulk add (calculator "add it all") ---------- */
  document.addEventListener('ob:addItems', function (e) {
    var items = e.detail && e.detail.items;
    if (!items || !items.length || !cartDrawer) return;
    addCartItems({
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }, 'Could not add to cart')
      .then(function () { announce('Added to cart'); cartDrawer.open(); })
      .catch(function (err) {
        if (typeof e.detail.onError === 'function') e.detail.onError(err);
        else if (err.cartAddBlocked) announce(err.message);
        else window.location.href = '/cart';
      })
      .then(function () { if (typeof e.detail.onComplete === 'function') e.detail.onComplete(); });
  });

  /* ---------- complete-the-fence picket addon ---------- */
  var addon = document.querySelector('[data-addon]');
  if (addon) {
    var pickSel = addon.querySelector('[data-addon-select]');
    var pickQty = addon.querySelector('[data-addon-qty]');
    var pickDispatch = addon.querySelector('[data-addon-dispatch]');
    var pickChoice = addon.querySelector('[data-addon-choice]');
    var pickSubtotal = addon.querySelector('[data-addon-subtotal]');
    var pickSuggest = addon.querySelector('[data-addon-suggest]');
    var pickButton = addon.querySelector('[data-addon-add]');
    var pickBusy = false;
    var spacing = parseInt(addon.getAttribute('data-spacing'), 10) || 4;

    var rollMatch = (addon.getAttribute('data-mesh-title') || '').match(/([\d,]+)\s*m\b/i);
    if (rollMatch) {
      var metres = parseInt(rollMatch[1].replace(/,/g, ''), 10);
      if (metres > 0) {
        pickQty.value = Math.floor(metres / spacing) + 1;
        pickSuggest.textContent = (addon.getAttribute('data-suggestion') || '').replace('{metres}', metres).replace('{spacing}', spacing);
      }
    }

    var validPicketChoice = function () {
      var opt = pickSel.options[pickSel.selectedIndex];
      var quantity = Number(pickQty.value);
      var variantId = Number(pickSel.value);
      return !!opt && opt.getAttribute('data-single') === 'true' && !opt.disabled &&
        Number.isSafeInteger(variantId) && variantId > 0 && Number.isSafeInteger(quantity) && quantity > 0;
    };
    var syncAddon = function () {
      var opt = pickSel.options[pickSel.selectedIndex];
      var dispatch = opt ? opt.getAttribute('data-dispatch') || '' : '';
      if (pickChoice) {
        pickChoice.textContent = opt && opt.getAttribute('data-single') === 'true' ? opt.textContent.trim() : '';
        pickChoice.hidden = !pickChoice.textContent;
      }
      pickButton.disabled = pickBusy || !validPicketChoice();
      if (pickSubtotal) {
        pickSubtotal.textContent = '';
        var unitCents = opt ? Number(opt.getAttribute('data-price-cents')) : 0;
        var totalCents = unitCents * Number(pickQty.value);
        if (validPicketChoice() && Number.isSafeInteger(unitCents) && unitCents > 0 && Number.isSafeInteger(totalCents)) {
          try {
            var totalMoney = new Intl.NumberFormat('en-AU', { style: 'currency', currency: addon.getAttribute('data-currency') }).format(totalCents / 100);
            pickSubtotal.textContent = (addon.getAttribute('data-subtotal') || '').replace('__QUANTITY__', pickQty.value).replace('__TOTAL__', totalMoney);
          } catch (err) { /* Missing currency must not interrupt the existing add-to-cart flow. */ }
        }
        pickSubtotal.hidden = !pickSubtotal.textContent;
      }
      if (pickDispatch) {
        pickDispatch.textContent = dispatch;
        pickDispatch.hidden = !dispatch;
      }
    };
    pickSel.addEventListener('change', syncAddon);
    pickQty.addEventListener('input', syncAddon);
    syncAddon();

    pickButton.addEventListener('click', function () {
      if (pickBusy || !validPicketChoice()) return;
      var btn = this, orig = btn.textContent;
      var opt = pickSel.options[pickSel.selectedIndex];
      var payload = { id: Number(pickSel.value), quantity: Number(pickQty.value) };
      var dispatch = opt.getAttribute('data-dispatch');
      if (dispatch) payload.properties = { Dispatch: dispatch };
      pickBusy = true;
      btn.disabled = true; btn.textContent = addon.getAttribute('data-adding') || orig;
      var old = addon.querySelector('.form-err');
      if (old) old.remove();
      addCartItems({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }, addon.getAttribute('data-error'))
        .then(function () { announce(addon.getAttribute('data-added')); if (cartDrawer) cartDrawer.open(); })
        .catch(function (err) {
          var p = document.createElement('p');
          p.className = 'form-err';
          p.setAttribute('role', 'alert');
          p.textContent = err.message || addon.getAttribute('data-error');
          if (!err.cartAddBlocked) {
            var link = document.createElement('a');
            link.href = window.OB_CART_URL || '/cart';
            link.textContent = window.OB_CART_CHECK_LABEL;
            p.appendChild(document.createTextNode(' '));
            p.appendChild(link);
          }
          addon.querySelector('.addon__body').appendChild(p);
        })
        .then(function () { pickBusy = false; btn.textContent = orig; syncAddon(); });
    });
  }

  /* ---------- email capture pop-up (exit-intent desktop / delay mobile) ----------
     One show per session via session cookie (no expiry); year-long cookie after
     signup. Suppressed while any drawer is open (html.no-scroll) — retries later. */
  var popup = document.getElementById('ob-popup');
  if (popup) {
    var POPUP_COOKIE = 'ob_popup_seen';
    var POPUP_INTENT = 'ob_popup_submit';
    var popupResponse = popup.querySelector('[data-popup-response]');
    var popupResponseDismissed = false;
    var popupOwnResponse = false;
    try {
      var popupIntent = JSON.parse(sessionStorage.getItem(POPUP_INTENT) || 'null');
      var popupIntentAge = popupIntent && Date.now() - popupIntent.at;
      popupOwnResponse = Boolean(popupResponse && popupIntent && popupIntent.path === window.location.pathname && popupIntentAge >= 0 && popupIntentAge <= 600000);
    } catch (_) { /* Without safe local ownership, never claim another form's response. */ }
    document.addEventListener('submit', function (event) {
      var form = event.target;
      var type = form.querySelector && form.querySelector('input[name="form_type"]');
      if (event.defaultPrevented || !type || type.value !== 'customer') return;
      try {
        if (form === popup.querySelector('#OBPopupCustomerForm')) sessionStorage.setItem(POPUP_INTENT, JSON.stringify({ at: Date.now(), path: window.location.pathname }));
        else sessionStorage.removeItem(POPUP_INTENT);
      } catch (_) { /* A storage restriction must not prevent the native submission. */ }
    });
    var popupSeen = function () { return document.cookie.indexOf(POPUP_COOKIE + '=') !== -1; };
    var popupMark = function (days) {
      document.cookie = POPUP_COOKIE + '=1; path=/; SameSite=Lax' + (days ? '; max-age=' + days * 86400 : '');
    };
    var popupOpen = function () {
      if (drawerIsOpen()) return;
      popup.hidden = false;
      popup.removeAttribute('aria-hidden');
      if (window.matchMedia('(min-width: 768px)').matches) {
        var email = popup.querySelector('input[type="email"]');
        if (email) email.focus();
      } else {
        /* mobile bottom sheet must clear the sticky ATC bar — measure the real
           bar height (it varies with title wrap) instead of trusting the CSS guess */
        var bar = document.getElementById('stickybar');
        if (bar) {
          var h = bar.offsetHeight;
          if (!h) {
            bar.style.visibility = 'hidden';
            bar.classList.add('is-on');
            h = bar.offsetHeight;
            bar.classList.remove('is-on');
            bar.style.visibility = '';
          }
          if (h) popup.querySelector('.popup__panel').style.marginBottom = 'calc(' + (h + 12) + 'px + env(safe-area-inset-bottom))';
        }
      }
    };
    var popupClose = function () {
      popupResponseDismissed = true;
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
    };
    var popupTry = function () {
      if (popupSeen() || !popup.hidden) return;
      if (document.querySelector('.cgp-setup')) return;
      if (document.getElementById('growth-kits')) return;
      if (drawerIsOpen()) { setTimeout(popupTry, 8000); return; }
      popupMark();
      popupOpen();
    };
    popup.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) popupClose(); });
    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { popupClose(); return; }
      if (window.matchMedia('(min-width: 768px)').matches) trapTab(popup.querySelector('.popup__panel'), e);
    });
    var revealPopupResponse = function () {
      if (popupResponseDismissed || !popupOwnResponse) return;
      if (drawerIsOpen()) { setTimeout(revealPopupResponse, 8000); return; }
      popupOpen();
      if (popup.hidden) return;
      popupOwnResponse = false;
      try { sessionStorage.removeItem(POPUP_INTENT); } catch (_) { /* Already shown in this page instance. */ }
      if (popup.querySelector('[data-popup-posted]')) popupMark(365);
      popupResponse.focus();
    };
    if (popupOwnResponse) {
      revealPopupResponse();
    } else if (!popupResponse && !popupSeen()) {
      if (window.matchMedia('(max-width: 767px)').matches) {
        setTimeout(popupTry, (parseInt(popup.getAttribute('data-delay'), 10) || 30) * 1000);
      } else {
        document.addEventListener('mouseleave', function onExit(e) {
          if (e.clientY > 0) return;
          document.removeEventListener('mouseleave', onExit);
          popupTry();
        });
      }
    }
  }

  /* ---------- VA-017 setup selector: id, price and addon base follow the choice ---------- */
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-setup] input[type="radio"]');
    if (!r || !r.checked || r.disabled) return;
    var form = r.closest('form');
    var idi = form && form.querySelector('input[name="id"]');
    if (idi) idi.value = r.value;
    if (r.getAttribute('data-label')) document.querySelectorAll('[data-cgp-quick-name]').forEach(function (n) { n.textContent = r.getAttribute('data-label'); });
    var pp = document.getElementById('p-price');
    var priceTemplate = r.closest('label').querySelector('template[data-cgp-price]');
    if (pp && priceTemplate) pp.replaceChildren(priceTemplate.content.cloneNode(true));
    else if (pp && r.getAttribute('data-price')) pp.innerHTML = r.getAttribute('data-price') + ' <small>inc GST</small>';
    var sp = document.getElementById('s-price');
    if (sp && r.getAttribute('data-price')) sp.textContent = r.getAttribute('data-price');
    var ab = form && form.querySelector('[data-addons]');
    if (ab) { ab.setAttribute('data-base', r.getAttribute('data-cents') || ab.getAttribute('data-base')); ab.dispatchEvent(new Event('change', { bubbles: true })); }
    if (r.hasAttribute('data-cgp-postable')) {
      var needsTemplate = r.closest('label').querySelector('template[data-cgp-needs-template]');
      var needsNote = form.querySelector('[data-cgp-needs]');
      if (needsNote && needsTemplate) needsNote.textContent = needsTemplate.content.textContent.trim();
      var delivery = form.querySelector('[data-cgp-delivery]');
      if (delivery) delivery.hidden = r.getAttribute('data-cgp-postable') !== 'true';
      var stockTemplate = r.closest('label').querySelector('template[data-cgp-stock]');
      var info = form.closest('.pdp__info');
      var oldStock = info && info.querySelector(':scope > .stockb');
      var newStock = stockTemplate && stockTemplate.content.querySelector('.stockb');
      if (oldStock && newStock) oldStock.replaceWith(newStock.cloneNode(true));
      var submit = form.querySelector('[data-cgp-submit]');
      if (submit) submit.disabled = form.hasAttribute('data-add-pending');
    }
    var orderSummary = form && form.querySelector('[data-cgp-order]');
    if (orderSummary) orderSummary.dispatchEvent(new Event('ob:setup-updated'));
  });
  var initialSetup = document.querySelector('[data-setup] input[type="radio"]:checked');
  if (initialSetup) initialSetup.dispatchEvent(new Event('change', { bubbles: true }));
  document.addEventListener('submit', function (e) {
    var setup = e.target.querySelector('.cgp-setup');
    if (!setup) return;
    var choice = setup.querySelector('input[type="radio"]:checked');
    var selectedId = e.target.querySelector('input[name="id"]');
    var orderQuantity = e.target.querySelector('[name="quantity"]');
    var rawQuantity = orderQuantity ? orderQuantity.value.trim() : '';
    var quantityNumber = Number(rawQuantity);
    var selectedCents = choice && Number(choice.getAttribute('data-cents'));
    var quantityValid = /^\d+$/.test(rawQuantity) && Number.isSafeInteger(quantityNumber) && quantityNumber > 0 && Number.isSafeInteger(selectedCents) && selectedCents > 0 && Number.isSafeInteger(selectedCents * quantityNumber);
    if (!choice || choice.disabled || !selectedId || selectedId.value !== choice.value || !quantityValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* ---------- Clipgun Add under the price (mobile audit 10 Oct) ----------
     Presses the real Add button (like the sticky bar), so the one submit path handles checks,
     extras, errors and the drawer. Mirrors the form's pending state so a second tap can't double-add. */
  var quick = document.querySelector('[data-cgp-quick]');
  var quickSubmit = quick && document.querySelector('form [data-cgp-submit]');
  if (quick && quickSubmit) {
    var quickForm = quickSubmit.form;
    var quickHtml = quick.innerHTML;
    var quickSync = function () {
      var pending = quickForm.hasAttribute('data-add-pending');
      quick.disabled = pending || quickSubmit.disabled;
      if (pending) { quick.textContent = 'Adding…'; quick.setAttribute('aria-busy', 'true'); return; }
      if (!quick.hasAttribute('aria-busy')) return;
      quick.innerHTML = quickHtml; quick.removeAttribute('aria-busy');
      var picked = quickForm.querySelector('.cgp-setup input:checked');
      var name = quick.querySelector('[data-cgp-quick-name]');
      if (picked && name && picked.getAttribute('data-label')) name.textContent = picked.getAttribute('data-label');
    };
    quick.addEventListener('click', function () {
      if (quickForm.hasAttribute('data-add-pending') || quickSubmit.disabled) return;
      quickHtml = quick.innerHTML;
      quickSubmit.click();
    });
    if ('MutationObserver' in window) new MutationObserver(quickSync).observe(quickForm, { attributes: true, attributeFilter: ['data-add-pending'] });
  } else if (quick) {
    quick.hidden = true;
  }

  /* ---------- Clipgun selected order and sticky total ---------- */
  document.querySelectorAll('[data-cgp-order]').forEach(function (summary) {
    var form = summary.closest('form');
    if (!form) return;
    var lines = summary.querySelector('[data-cgp-order-lines]');
    var total = summary.querySelector('[data-cgp-order-total]');
    var extrasNote = summary.querySelector('[data-cgp-order-extras]');
    var stickyName = document.querySelector('[data-cgp-sticky-name]');
    var stickyPrice = stickyName && document.getElementById('s-price');
    var formatter;
    try { formatter = new Intl.NumberFormat(summary.dataset.currency === 'AUD' ? 'en-AU' : (document.documentElement.lang || 'en-AU'), { style: 'currency', currency: summary.dataset.currency }); } catch (err) { return; }
    var money = function (cents) { return formatter.format(cents / 100); };
    var updateOrder = function () {
      var choice = form.querySelector('.cgp-setup input:checked');
      var quantity = form.querySelector('[name="quantity"]');
      var raw = quantity ? quantity.value.trim() : '1';
      var amount = Number(raw);
      var base = choice && Number(choice.getAttribute('data-cents'));
      var quantityValid = /^\d+$/.test(raw) && Number.isSafeInteger(amount) && amount > 0 && Number.isSafeInteger(base * amount);
      if (quantity) quantity.setCustomValidity(quantityValid ? '' : summary.dataset.invalid);
      var valid = choice && !choice.disabled && quantityValid && Number.isSafeInteger(base) && base > 0 && Number.isSafeInteger(base * amount);
      lines.replaceChildren();
      extrasNote.hidden = true;
      summary.hidden = false;
      summary.classList.remove('is-single');
      if (!valid) {
        total.textContent = summary.dataset.invalid; total.setAttribute('data-invalid', '');
        if (stickyName) stickyName.textContent = choice ? choice.getAttribute('data-label') : '';
        if (stickyPrice) stickyPrice.textContent = summary.dataset.invalid;
        return;
      }
      total.removeAttribute('data-invalid');
      var title = choice.getAttribute('data-label');
      var sum = base * amount;
      var addLine = function (label, qty, cents) {
        var row = document.createElement('li');
        var name = document.createElement('span');
        var price = document.createElement('span');
        name.textContent = qty + ' × ' + label; price.textContent = money(cents * qty);
        row.append(name, price); lines.append(row);
      };
      addLine(title, amount, base);
      form.querySelectorAll('[data-addon-check]:checked').forEach(function (extra) {
        var extraPrice = Number(extra.getAttribute('data-price'));
        var extraQty = extra.hasAttribute('data-match-main-qty') ? amount : 1;
        var label = extra.getAttribute('data-label') || extra.closest('label').querySelector('span').textContent.trim();
        sum += extraPrice * extraQty;
        addLine(label, extraQty, extraPrice);
        extrasNote.hidden = false;
      });
      total.textContent = money(sum);
      // Bible ruling 20 #4: with one setup and no extras the summary only repeats the price, so it stays
      // folded away and the Add button sits higher on phones. It opens as soon as it says something new.
      summary.classList.toggle('is-single', amount === 1 && extrasNote.hidden);
      if (stickyName) stickyName.textContent = amount + ' × ' + title;
      if (stickyPrice) stickyPrice.textContent = summary.dataset.stickyTotal + ' ' + money(sum);
    };
    form.addEventListener('input', updateOrder);
    form.addEventListener('change', updateOrder);
    summary.addEventListener('ob:setup-updated', updateOrder);
    updateOrder();
  });

  /* ---------- overseas visitor → their Clipgun store (Josh ruling 18) ----------
     Shopify's browsing-context endpoint geolocates the visitor. Every country other than
     Australia gets the banner; it never redirects, and any failure leaves it hidden. */
  var geoBanner = document.getElementById('geo-store');
  if (geoBanner && window.fetch) {
    var GEO_STORES = { US: 'en-us', CA: 'en-ca', GB: 'en-gb', IE: 'en-ie', DE: 'en-eu', FR: 'en-eu', NL: 'en-eu', BE: 'en-eu', AT: 'en-eu', SE: 'en-nordics', NO: 'en-nordics', DK: 'en-nordics', FI: 'en-nordics', NZ: 'en-nz', ZA: 'en-za' };
    var geoDismissed = false;
    try { geoDismissed = localStorage.getItem('ob_geo_dismiss') === '1'; } catch (_) { /* storage blocked: still offer the store */ }
    var showGeo = function (country) {
      /* 25 Oct 2026: any non-Australian country gets the pointer. Known Clipgun markets go straight to
         their subfolder; everyone else goes through ?country=XX and Shopify picks the market. */
      if (!country || !country.handle || country.handle === 'AU') return;
      var name = country.name || country.handle;
      var path = (GEO_STORES[country.handle] ? '/' + GEO_STORES[country.handle] + '/' : '/') + (geoBanner.dataset.productPath || '');
      geoBanner.querySelector('[data-geo-text]').textContent = geoBanner.dataset.text.split('%COUNTRY%').join(name);
      var go = geoBanner.querySelector('[data-geo-go]');
      go.textContent = geoBanner.dataset.cta.split('%COUNTRY%').join(name);
      go.href = path + '?country=' + encodeURIComponent(country.handle) + (geoBanner.dataset.productPath ? '' : '#icg-kits');
      geoBanner.hidden = false;
    };
    if (!geoDismissed) {
      var geoCached = null;
      try { geoCached = JSON.parse(sessionStorage.getItem('ob_geo') || 'null'); } catch (_) { geoCached = null; }
      if (geoCached && geoCached.handle) {
        showGeo(geoCached);
      } else if (!geoCached) {
        fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var c = data && data.detected_values && data.detected_values.country;
            var country = c && c.handle ? { handle: String(c.handle).toUpperCase(), name: c.name } : { handle: '' };
            try { sessionStorage.setItem('ob_geo', JSON.stringify(country)); } catch (_) { /* fetch again next page */ }
            showGeo(country);
          })
          .catch(function () { /* no banner: the Australian site keeps working */ });
      }
    }
    geoBanner.querySelector('[data-geo-dismiss]').addEventListener('click', function () {
      geoBanner.hidden = true;
      try { localStorage.setItem('ob_geo_dismiss', '1'); } catch (_) { /* dismissed for this page only */ }
    });
  }

  /* ---------- hero video (about page): reduced-motion + tap-to-pause (WCAG 2.2.2) ---------- */
  var heroVids = document.querySelectorAll('video[data-hero-video]');
  if (heroVids.length) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    heroVids.forEach(function (v) {
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      v.style.cursor = 'pointer';
      v.setAttribute('role', 'button');
      v.setAttribute('tabindex', '0');
      var toggle = function () { if (v.paused) { v.play(); } else { v.pause(); } };
      v.addEventListener('click', toggle);
      v.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
    });
  }
})();


